<template>
    <div id="calendar" class="docker__item">
      <van-cell title="往期" :value="date" @click="show = true">
        <van-icon name="calendar-o" size=".6rem" />
        <span class="docker__item__text">往期</span>
      </van-cell>
      <van-popup
        id="docker__item__calender"
        v-model:show="show"
        :style="{height:'80%',width: '100% '}"
      >
        <!-- <van-datetime-picker
          v-model="nowDate"
          type="date"
          title="选择年月日"
          cancel-button-text=""
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirm"
          @cancel="onCancel"
        /> -->
        <!-- <van-cell title="选择单个日期" :value="date" @click="show = true" />
        <van-calendar
          v-model:show="show"
          @confirm="onConfirm"
          :readonly="readonly"
        /> -->
        <a-calendar
          v-model:value="value"
          :fullscreen="false"
          :disabled-date="disabledDate"
          @select="onSelect"
        />
      </van-popup>
    </div>
</template>
<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import dayjs from 'dayjs'
import { get } from '../../utils/request'
export default {
  name: 'CalendarList',
  props: {
    newspaperId: String
  },
  setup (props, { emit }) {
    const value = ref()
    const show = ref(false)
    const nowDate = ref('')
    const date = ref('')
    // const currentDate = ref('')
    const store = useStore()
    const pageDate = ref()
    const minDate = new Date(1991, 0, 1)
    const maxDate = new Date(2025, 10, 1)
    const dateList = ref([])
    const routeIndex = ref()
    const router = useRouter()
    const route = useRoute()
    const routePageDate = ref('')
    routePageDate.value = route.params.pageDate
    const currentPageDate = computed(() => store.state.pageDate)
    const newspaper = computed(() => store.state.newspaper)
    const getDateList = async () => {
      const url = `pageDateController/getPageDateList?newspaperId=${props.newspaperId}`
      const result = await get(url)
      result.list.map((item, index) => {
        const pageDate = item.pageDate
        dateList.value.push(pageDate)
      })
      if (routePageDate.value !== '') {
        routeIndex.value = dateList.value.indexOf(routePageDate.value)
      }
      if (routePageDate.value && routeIndex.value !== -1) {
        value.value = routePageDate.value
        pageDate.value = routePageDate.value
      } else if (routePageDate.value === '') {
        value.value = dateList.value[0]
        pageDate.value = dateList.value[0]
      } else {
        // alert('该日期无数据，即将跳转到最新一期！')
        value.value = dateList.value[0]
        pageDate.value = dateList.value[0]
      }
      if (currentPageDate.value !== '') {
        value.value = currentPageDate.value
      }
      // store.dispatch('getPageDate', pageDate.value)
      emit('getPageDate', pageDate.value)
      // for (let i = 0; i < result.list.length; i++) {
      //   const dateItem = result.list[i].pageDate
      //   allDateList.value.push(dateItem)
      //   if (dateList.value.indexOf(dateItem.substr(0, 4)) === -1) {
      //     dateList.value.push(dateItem.substr(0, 4))
      //   }
      //   const first = allDateList.value[0]
      //   if (dateItem === first) {
      //     store.dispatch('getPageDate', dateItem)
      //     emit('getPageDate', dateItem)
      //     currentDate.value = dateItem
      //     nowDate.value = new Date(dateItem)
      //   }
      // }
    }
    getDateList()
    // const readonly = () => {
    //   return dayjs()
    // }
    // const getCurrentDate = () => {
    //   if (pageDate.value === '') {
    //     getDateList()
    //   } else {
    //     emit('getPageDate', pageDate.value)
    //     nowDate.value = new Date(pageDate.value)
    //   }
    // }
    // getCurrentDate()
    const disabledDate = (current) => {
      let selectDate = false
      selectDate = !dateList.value.some((son, index, arr) => {
        return current.isSame(son, 'day')
      })
      return selectDate
    }
    // const formatDate = (date) => `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    const formatDate = (date) => {
      // const date = new Date(date)
      let dateStr = date.getFullYear() + '-'
      if (date.getMonth() < 9) {
        dateStr += '0'
      }
      dateStr += date.getMonth() + 1 + '-'
      dateStr += date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      dateStr += ' '
      return dateStr
    }
    const onSelect = (date) => {
      show.value = false
      const prevDate = new Date(date)
      const newDate = formatDate(prevDate, 'YYYY-MM-DD')
      emit('getPageDate', newDate)
      // date.value = formatDate(value)
      // emit('getPageDate', date.value)
      // value.value = pageDate.value
      store.dispatch('getPageDate', newDate)
      store.dispatch('getSwiperIndex', 0)
      router.push({
        path: '/' + newspaper.value + '/' + newDate
      })
      // store.dispatch('getPageDate', date.value)
      // if (allDateList.value.indexOf(date.value) !== -1) {
      //   store.dispatch('getPageDate', date.value)
      // }
    }
    const onCancel = () => {
      show.value = false
    }
    const showPopup = () => {
      show.value = true
    }
    return {
      show,
      value,
      showPopup,
      nowDate,
      minDate,
      maxDate,
      date,
      dayjs,
      onSelect,
      onCancel,
      disabledDate
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/variables.scss';
.docker__item {
    flex: 1;
    text-align: center;
    color: $content-fontcolor;
    &__text{
      font-size: .45rem;
      margin-bottom: 1rem;
    }
  }
</style>
